import { autoCapitalize } from '@/utils/autoCapitalize'
import { ExportLogsData } from './ExportLogsMapper.types'

class ExportLogsListMapper {
  toDomain(persistenceExportLogs: ExportLogsData) {
    return {
      appontmentsId: persistenceExportLogs?.idAppontments,
      clinicId: persistenceExportLogs?.idClinic,
      exportDateTime: persistenceExportLogs?.exportDateTime,
      exportLogId: persistenceExportLogs?.idExportLog,
      exportStatus: persistenceExportLogs?.exportStatus,
      clinicName: autoCapitalize(persistenceExportLogs?.nameClinic),
      nameResponsibleUser: autoCapitalize(
        persistenceExportLogs?.nameResponsibleUser,
      ),
      patientId: persistenceExportLogs?.idPatient,
      patientName: autoCapitalize(persistenceExportLogs?.patientName),
      responsibleUserId: persistenceExportLogs?.idResponsibleUser,
      receivedMedicalRecordEmail:
        persistenceExportLogs?.emailReceivedMedicalRecord,
    }
  }
}

export default new ExportLogsListMapper()
